module.exports = __webpack_public_path__ + "static/media/ks_shack_background_sm.b863b1fb.jpg";